module.exports = __webpack_public_path__ + "media/fonts/material-design-icons/materialdesignicons-webfont-a7b7f4755a618ee22850085a6bd8cf90.ttf";